import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { updateUserInfo } from "../../api";
import GenderInput from "./GenderInput";
import BirthDateInput from "./BirthDateInput";
import SchoolInput from "./SchoolInput";

const InfoForm = ({ id, handleSkip, afterSave }) => {
  const queryClient = useQueryClient();
  const [data, setData] = useState({
    birth_date: "",
    school: null,
    gender: null,
  });
  const [error, setError] = useState("");

  const { mutate: updateMutation } = useMutation({
    mutationFn: updateUserInfo,
    onSettled: (result) => {
      if (result && result.result) {
        return afterSave(data);
      }
      setError(result.error);
      queryClient.invalidateQueries({ queryKey: ["user/update"] });
    },
  });

  const handleChange = (e) => {
    const { value: val, id: target } = e.target;
    if (target === "birth_date" || target === "school") {
      setData({ ...data, [target]: val });
    } else {
      const [k, v] = target.split("_");
      setData({ ...data, [k]: v.toUpperCase() });
    }
  };

  const handleNext = () => {
    updateMutation({ ...data, id });
  };

  return (
    <div className="card-body">
      <GenderInput
        {...{
          gender: data.gender,
          onChange: handleChange,
          className: "h-12 text-sm",
        }}
      />
      <BirthDateInput
        {...{ birth_date: data.birth_date, onChange: handleChange }}
      />
      <SchoolInput {...{ data, onChange: handleChange, setError }} />
      <div className="form-control mt-6">
        {error && <span className="text-sm mb-1 text-red-500">{error}</span>}
        <button
          className="btn btn-primary"
          disabled={!(data.birth_date || data.school || data.gender)}
          onClick={handleNext}
        >
          다음
        </button>
      </div>
      <div className="form-control">
        <hr />
        <button
          className="btn btn-ghost btn-sm p-0 mt-3 text-accent"
          onClick={handleSkip}
        >
          다음에 입력하기
        </button>
      </div>
    </div>
  );
};

export default InfoForm;
